/** Fremdriftstid for innloggingsanimasjonen (ms) — delt av LoginSection og ClientUiShell */
export const LOGIN_ANIM_MS = 5000;
/** Stille pause etter ferdig animasjon, før dashbordet tones frem (ms) */
export const LOGIN_HOLD_MS = 1000;
